"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadstromMutexBase = void 0;
class CadstromMutexBase {
    async runOperation(operation) {
        await this.acquire();
        try {
            return await operation();
        }
        finally {
            await this.release();
        }
    }
    async [Symbol.asyncDispose]() {
        await this.release();
    }
}
exports.CadstromMutexBase = CadstromMutexBase;
//# sourceMappingURL=cadstrom-mutex-base.js.map